// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0e70abdf","239":"2e853fcd","667":"d325292f"}[chunkId] + ".chunk.js";
};